export const NaluriVideoErrorConstants = {
  ROOM_NOT_FOUND: 1001,
  ROOM_NOT_ACCESSIBLE: 1002,
  INVALID_ROOM_STATUS: 1003,
  USER_NOT_AUTHORIZED: 1004,
  LOGOUT_FAILED: 1005,
  FETCH_MISSING: 9999,
  UNKNOWN_ERROR: 9998,
} as const;
